module.exports = "https://coursera_assets.s3.amazonaws.com/images/9b7e964107839c77644d7e7d15035b73.png";